import React, {useEffect} from 'react';
import L from 'leaflet'
import { useMap } from 'react-leaflet';
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.js";

const Geocoder = () => {
    const map = useMap()
    
    useEffect(()=>{

        L.Control.geocoder({
            defaultMarkGeocode: false,
            placeholder: "郵便番号または住所で検索",
            errorMessage: "見つかりませんでした",
        }).on("markgeocode", function(e){
            map.setView(e.geocode.center)

        }).addTo(map)

    }, [map])
    return null
}
export default Geocoder;
